import { PropsWithChildren } from 'react';

import { Flag } from '@utils';

import { FlagMiddleware } from './FlagMiddleware';
import { PermissionMiddleware } from './PermissionMiddleware';
import { Permission } from '@common/utils/admin_permissions';

export interface ApplyMiddlewaresProps {
  flag?: Flag;
  permissions?: Permission[];
}

export function ApplyMiddlewares({ children, flag, permissions }: PropsWithChildren<ApplyMiddlewaresProps>) {
  if (permissions) {
    children = <PermissionMiddleware permissions={permissions}>{children}</PermissionMiddleware>;
  }

  if (flag) {
    children = <FlagMiddleware flag={flag}>{children}</FlagMiddleware>;
  }

  return <>{children}</>;
}
